import type { NavigableRouteType } from '@/router/types';

import { instance } from './appRoutes';

export const aiVisibility = {
  path: `${instance.path}/ai-visibility`,
  description:
    'AI Visibility settings and reports for measuring how the instance appears in AI-generated answers.',
  navigable: true,
  pathParams: {},
  searchParams: {},
} satisfies NavigableRouteType;

export const aiVisibilityOverview = {
  ...aiVisibility,
  path: `${aiVisibility.path}/overview`,
  description: 'An overview of AI Visibility for the instance.',
} satisfies NavigableRouteType;

export const aiVisibilityPrompts = {
  ...aiVisibility,
  path: `${aiVisibility.path}/prompts`,
  description: 'Prompts used to measure AI Visibility for the instance.',
} satisfies NavigableRouteType;

export const aiVisibilityRecommendations = {
  ...aiVisibility,
  path: `${aiVisibility.path}/recommendations`,
  description: 'Recommendations for improving AI Visibility for the instance.',
} satisfies NavigableRouteType;

export const aiVisibilityContent = {
  ...aiVisibility,
  path: `${aiVisibility.path}/content`,
  description: 'Content related to AI Visibility for the instance.',
} satisfies NavigableRouteType;

export const aiVisibilityCompetitors = {
  ...aiVisibility,
  path: `${aiVisibility.path}/competitors`,
  description: 'Competitor AI Visibility for the instance.',
} satisfies NavigableRouteType;

export const aiVisibilitySettings = {
  ...aiVisibility,
  path: `${aiVisibility.path}/settings`,
  description: 'AI Visibility settings for the instance.',
} satisfies NavigableRouteType;
